import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Checklists, { ChecklistType, SubitemChecklist } from '../../../../service/Checklists';
import { TabStyle } from '../../../TabsStyle/TabsStyle';
import AssociationTab from './AssociationTab';
import { TabDiv } from './FormModalStyle';
import GeneralTab from './GeneralTab';
import RangeScoringTab from './RangeScoringTab';
import SubItemTab from './SubItemTab';
import FillingConfig from './FillingConfig';
import FormChamadosConfig from './FormChamadosConfig';
import NotifiConfig from './NotifiConfig';
import { UserContext } from '../../../../context/UserContext';
import { trackEventMatomo } from '../../../../helpers/matomo';
import QrCodesList from './QrCodesList';
import HeaderModal from '../../../HeaderModal/HeaderModal';
import FooterModal from '../../../FooterModal/FooterModal';
import QueryFn from '../../../../helpers/QueryFn';
import AttToken from '../../../../helpers/attToken';
import { toast } from 'react-toastify';
import queryClient from '../../../../service/query';

type props = {
  editModal: number,
  setEditModal: Function,
  form: ChecklistType,
  formIndex: number,
  typeExists: boolean,
  refetchChecklists: Function
};

export type generalType = {
  chamadoObrigatorio: boolean,
  cliente: string,
  delegacao: boolean,
  distanciaLimite: number | undefined,
  duracaoValidade: number,
  empresa: string,
  formulario: string,
  gravaPOS: boolean,
  id: string,
  limiteChamado: number,
  qrcode: boolean,
  tipoChamado: number[],
  tipoValidade: string | null,
};

const initialState: generalType = {
  chamadoObrigatorio: false,
  cliente: "",
  delegacao: false,
  distanciaLimite: undefined,
  duracaoValidade: 0,
  empresa: "",
  formulario: "",
  gravaPOS: false,
  id: "",
  limiteChamado: 0,
  qrcode: false,
  tipoChamado: [],
  tipoValidade: ""
};

const checklistService = new Checklists();
const queryFn = new QueryFn();

export default function FormModal({ editModal, setEditModal, form, formIndex, typeExists, refetchChecklists }: props) {
  const { t } = useTranslation('translation');
  const [checked, setChecked] = useState(form.range ? true : false);
  const [itemRange, setItemRange] = useState([
    {
      index: 0,
      name: t('formDetails.range_scoring.perfect'),
      range: 100,
    }
  ]);
  const [tipoServico, setTipoServico] = useState(typeExists ? form.tipoServico || '' : '');
  const formAnonimo = form.preenchimentoDeslogado && form.preenchimentoWeb;
  const [general, setGeneral] = useState<generalType>({ ...initialState, cliente: formAnonimo ? 'anonimo' : '' });
  const [selectedCustomer, setSelectedCustomer] = useState<string>(formAnonimo ? 'anonimo' : '');
  const [chamadoObrigatorio, setChamadoObrigatorio] = useState('naoconforme');
  const [tipoChamado, setTipoChamado] = useState<number[] | null>(null);
  const [limiteChamado, setLimiteChamado] = useState<number | null>(null);
  const [selectedSub, setSelectedSub] = useState('');
  const [canShow, setCanShow] = useState(false);
  const [disabled, setDisabled] = useState(false);

  const customerSelectRef = useRef<HTMLSelectElement>(null);
  const { userData, setChanged } = useContext(UserContext);

  const escape = useCallback((e: any): void => {
    if (e.key === 'Escape') {
      setEditModal(-1);
    }
  }, [setEditModal]);

  useEffect(() => {
    document.addEventListener('keydown', escape, true);
  }, [escape]);

  const mapNames = {
    association: t('checklists.formModal.associationTab'),
    filling: t('formDetails.preenchimento_web'),
    general: t('checklists.formModal.generalTab'),
    subitems: t('checklists.formModal.subitemsTab'),
    rangeScoring: t('checklists.formModal.rangeScoringTab'),
    configChamados: t('formDetails.configChamados.configChamados'),
    configNotifi: userData.migrado ? t('checklists.formModal.notificationSettings') : t('checklists.formModal.notificationSettings2'),
    qrCodesList: `${t('checklists.Modal.preFilledQRCodeList')}`
  };

  const [isTab, setIsTab] = useState({
    isActiveObject: form.preenchimentoDeslogado ? 'filling' : 'association',
    object: form.preenchimentoDeslogado ? !userData.migrado ? [
      'filling',
      'general',
      'subitems',
      'configChamados',
      'configNotifi',
      'rangeScoring'
    ] : [
      'filling',
      'configChamados',
      'configNotifi',
      'rangeScoring'
    ] : !userData.migrado ? [
      'association',
      'general',
      'subitems',
      'configChamados',
      'configNotifi',
      'rangeScoring'
    ] : [
      'association',
      'general',
      'configChamados',
      'configNotifi',
      'rangeScoring',
      'qrCodesList'
    ]
  });

  const toggleClass = (index: number) => {
    setIsTab({ ...isTab, isActiveObject: isTab.object[index] });
    trackEventMatomo('modal config form', 'click', 'tab', 'troca de aba');
  };

  const toggleActive = (index: number) => {
    if (isTab.object[index] === isTab.isActiveObject) {
      return "is-active";
    } else {
      return "inactve";
    }
  };

  const close = () => {
    setEditModal(-1);
  };

  const handleUpdateFn = async (objToSend: ChecklistType) => {
    setDisabled(true);
    toast.warn(`${t('saving')}`);
    try {
      const data = await AttToken();
      if (data) {
        const teams = await checklistService.updateChecklist(data, objToSend);
        setDisabled(false);
        toast.success(`${t('salvo')}`);
        refetchChecklists();
        return teams;
      }
    } catch (err) {
      console.error(err);
      setDisabled(false);
    }

  };

  const handleUpdateFn2 = async () => {
    setDisabled(true);
    toast.warn(`${t('saving')}`);
    try {
      const token = await AttToken();
      if (token) {
        const clienteFormulario = {
          chamadoObrigatorio: general.chamadoObrigatorio,
          cliente: general.cliente,
          delegacao: general.delegacao,
          distanciaLimite: isNaN(Number(general.distanciaLimite)) ? null : Number(general.distanciaLimite) || null,
          duracaoValidade: general.duracaoValidade,
          empresa: token.userEmpresa,
          formulario: form.id,
          gravaPOS: general.gravaPOS,
          id: `${general.cliente}_${form.id}`,
          limiteChamado: general.limiteChamado,
          qrcode: general.qrcode,
          tipoChamado: general.tipoChamado,
          tipoValidade: general.tipoValidade || null
        };
        const response = await checklistService.editConfigForm(token, form.id, general.cliente, clienteFormulario);
        if (customerSelectRef.current) customerSelectRef.current.value = '';
        setGeneral(prevState => prevState && { ...prevState, cliente: formAnonimo ? 'anonimo' : '' });
        toast.success(`${t('salvo')}`);
        setDisabled(false);
        // setEditModal(-1)
        refetchChecklists();
        return response;
      }
    } catch (err) {
      console.error(err);
      setDisabled(false);
    }
  };

  const handleUpdatFn3 = async () => {
    setDisabled(true);
    try {
      const token = await AttToken();
      if (token) {
        await checklistService.changeRange(token, itemRange, checked, form.id);
        queryClient.resetQueries({ queryKey: ['GET_CHECKLIST'] });
        toast.success(`${t('toast.rangeSaved')}`);
      }
      setDisabled(false);
    } catch (err) {
      console.error(err);
      setDisabled(false);
    }
  };

  const clearStates = () => {
    setChamadoObrigatorio('nãoConforme');
    setTipoChamado(null);
    setLimiteChamado(null);
    setSelectedSub('');
  };

  const editOptions = async () => {
    setDisabled(true);
    toast.warn(`${t('toast.savingSubitemSettings')}`);
    const token = await AttToken();
    if (token) {
      const sub: SubitemChecklist = JSON.parse(selectedSub);
      const result = await checklistService.editOptionsForSubitem(token, form.id, selectedCustomer, sub.new_id || null, Number(sub.id), sub.itemid, {
        chamadoObrigatorio,
        limiteChamado: limiteChamado || 0,
        nome: sub.nome,
        tipo: sub.tipo,
        tipoChamado: tipoChamado || []
      });
      if (result) {
        form.itens[Number(sub.itemid.split('|')[2])].subitens[Number(sub.id)].new_id = result.newId;
      }
      toast.success(`${t('toast.settingsSaved')}`);
      setDisabled(false);
      clearStates();
      setCanShow(false);
    }
  };

  const submit = () => {
    trackEventMatomo('modal config form', 'click', 'button', 'salva');
    switch (isTab.isActiveObject) {
      case 'association':
        {
          localStorage.setItem('changedHirarquia', 'true');
          setChanged(true);
          const objToSend: ChecklistType = {
            ...form,
            tipoServico
          };
          handleUpdateFn(objToSend);
        }
        break;
      case 'filling':
      case 'configChamados':
      case 'configNotifi':
        handleUpdateFn(form);
        break;
      case 'general':
        handleUpdateFn2();
        break;
      case 'subitems':
        editOptions();
        break;
      case 'rangeScoring':
        handleUpdatFn3();
        break;
    }
  };

  const mutate = queryFn.useMutate('UPDATE_FORM', submit);

  return (
    <>
      <div className={`modal ${editModal === formIndex ? "modal is-active" : "modal"}`}>
        <div className="modal-background" onKeyDown={(e) => escape(e)} onClick={() => setEditModal(-1)} />
        <div className="modal-card" onSubmit={(e: React.FormEvent) => e.preventDefault()}>
          <HeaderModal headerTitle={t('formDetails.configuracoesDeForm')} close={close} />
          <div className="modal-card-body">
            <TabDiv className="tabs is-boxed">
              <ul>
                {isTab.object.map((el, index) => (
                  <li key={index} className={toggleActive(index)} onClick={() => { toggleClass(index); }}>
                    <TabStyle theme={toggleActive(index)}>{mapNames[el as keyof typeof mapNames]}</TabStyle>
                  </li>
                ))}
              </ul>
            </TabDiv>
            {isTab.isActiveObject === 'association' && (
              <AssociationTab
                form={form}
                setEditModal={setEditModal}
                typeExists={typeExists}
                refetchChecklists={refetchChecklists}
                setTipoServico={setTipoServico}
                tipoServico={tipoServico}
              />
            )}
            {isTab.isActiveObject === 'filling' && (
              <FillingConfig
                form={form}
                formWeb={form.preenchimentoDeslogado}
                formId={form.id} />
            )}
            {isTab.isActiveObject === 'general' && (
              <GeneralTab
                setDisabled={setDisabled}
                disabled={disabled}
                formAnonimo={formAnonimo as boolean}
                general={general}
                setGeneral={setGeneral}
                formId={form.id}
                form={form}
              />
            )}
            {isTab.isActiveObject === 'subitems' && (
              <SubItemTab
                selectedCustomer={selectedCustomer}
                setSelectedCustomer={setSelectedCustomer}
                chamadoObrigatorio={chamadoObrigatorio}
                setChamadoObrigatorio={setChamadoObrigatorio}
                tipoChamado={tipoChamado}
                setTipoChamado={setTipoChamado}
                limiteChamado={limiteChamado}
                setLimiteChamado={setLimiteChamado}
                selectedSub={selectedSub}
                setSelectedSub={setSelectedSub}
                canShow={canShow}
                setCanShow={setCanShow}
                setEditModal={setEditModal}
                form={form}
                clearStates={clearStates}
              />
            )}
            {isTab.isActiveObject === 'configChamados' && (
              <FormChamadosConfig
                setEditModal={setEditModal}
                form={form} />
            )}
            {isTab.isActiveObject === 'configNotifi' && (
              <NotifiConfig
                form={form} />
            )}
            {isTab.isActiveObject === 'rangeScoring' && (
              <RangeScoringTab
                checked={checked}
                setChecked={setChecked}
                itemRange={itemRange}
                setItemRange={setItemRange}
                form={form}

              />
            )}
            {isTab.isActiveObject === 'qrCodesList' && (
              <QrCodesList
                setEditModal={setEditModal}
                form={form} />
            )}
          </div>
          {isTab.isActiveObject !== 'qrCodesList' && <FooterModal disabled={disabled} submit={mutate.mutateAsync} label={t('save')} />}
        </div>
      </div>
    </>
  );
}